module.exports = __webpack_public_path__ + "img/logo.92de18a9.png";